/**
 * DataBest — Refreshing overlay for dashboard tiles.
 *
 * Absolute-positioned semi-transparent layer with a centred spinner + pill,
 * shown while the parent's data is being refreshed. The stale content stays
 * visible underneath so the user sees continuity, not an empty state.
 */
import React from "react";
import { Loader2 } from "lucide-react";

const RefreshingOverlay = ({ visible, label = "Refreshing" }) => (
    <div
        aria-live="polite"
        aria-busy={visible || undefined}
        data-testid="dashboard-refreshing-overlay"
        className={`pointer-events-none absolute inset-0 z-10 flex items-center justify-center rounded-2xl bg-white/60 backdrop-blur-[2px] transition-opacity duration-200 ${
            visible ? "opacity-100" : "opacity-0"
        }`}
    >
        <div className="flex items-center gap-2 rounded-full border border-slate-200 bg-white px-3 py-1.5 text-[11px] font-bold uppercase tracking-widest text-slate-600 shadow-sm">
            <Loader2 className="h-3.5 w-3.5 animate-spin text-brand-blue-700" />
            {label}
        </div>
    </div>
);

export default RefreshingOverlay;
